<script setup>
// Abas de visão de uma tela (ex: Lista/Kanban/Calendário em Agendamentos).
// Abaixo de md vira uma lista suspensa (SelectPicker) — pills lado a lado
// não cabem numa tela estreita. A partir de md, a fileira de pills de sempre.
// Padrão trazido do financeiro-frontend (TabPills.vue de lá).
import { computed } from 'vue'
import SelectPicker from './SelectPicker.vue'

const props = defineProps({
  modelValue: { type: String, required: true },
  tabs: { type: Array, required: true }, // [{ id, label, icon }]
})
const emit = defineEmits(['update:modelValue'])

const selectOptions = computed(() => props.tabs.map((tab) => ({
  value: tab.id,
  label: tab.label,
  icon: tab.icon,
})))
</script>

<template>
  <!-- Raiz única: o class de quem usa (ex: "flex-1") cai aqui. -->
  <div>
    <!-- Fica direto sobre o fundo da página: mesmo visual de card das barras
         da tela e do ícone de filtros ao lado (MobileFilters), com a altura
         dele (44px). -->
    <div class="md:hidden">
      <SelectPicker
        :model-value="modelValue"
        :options="selectOptions"
        variant="gray"
        input-class="!min-h-[44px] !rounded-xl !bg-white dark:!bg-zinc-900 !border-slate-200/80 dark:!border-zinc-800 shadow-sm font-medium"
        @update:model-value="emit('update:modelValue', $event)"
      />
    </div>
    <div class="hidden md:flex items-center gap-1 bg-white dark:bg-zinc-900 rounded-xl p-1 border border-slate-200/80 dark:border-zinc-800 shadow-sm w-max max-w-full overflow-x-auto">
      <button
        v-for="tab in tabs"
        :key="tab.id"
        type="button"
        class="flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg transition-all duration-150 shrink-0"
        :class="modelValue === tab.id
          ? 'bg-primary-500 text-white shadow-sm'
          : 'text-slate-500 dark:text-zinc-400 hover:text-slate-700 dark:hover:text-zinc-200 hover:bg-slate-100 dark:hover:bg-zinc-800'"
        @click="emit('update:modelValue', tab.id)"
      >
        <component :is="tab.icon" v-if="tab.icon" class="w-4 h-4 shrink-0" />
        <span class="whitespace-nowrap">{{ tab.label }}</span>
      </button>
    </div>
  </div>
</template>
